module.exports = __webpack_public_path__ + "static/media/JewelReese.fbc64018.jpeg";